export default __webpack_public_path__ + "static/media/hexometer-logo-rectangle-white.50aaddd0.svg";